





















import Vue from 'vue'
import { getImageSrcset } from '../utils/common'

export default Vue.extend({
  props: {
    src: {
      type: String,
      required: true
    },
    placeHolderRatio: {
      type: String,
      default: 'is-square'
    },
    showPlaceholder: {
      type: Boolean,
      default: true
    },
    alt: {
      type: String,
      default: ''
    },
    variantName: {
      type: String,
      default: ''
    }
  },
  data(): {
    nativeLazyLoaded: boolean
  } {
    return {
      nativeLazyLoaded: false
    }
  },
  computed: {
    dataSrcset(): string {
      return this.variantName ? getImageSrcset(this.src, this.variantName) : ''
    }
  },
  methods: {
    doneLoading() {
      this.nativeLazyLoaded = true
    }
  }
})
